<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import en from './en.json';
import ru from './ru.json';

const props = defineProps({
  field: { type: Object, default: () => ({}) },
  modelValue: { type: [String, Number, Boolean, Array], default: null },
  contains: Boolean,
  label: { type: String, required: true },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n({ useScope: 'local', messages: { en, ru } });

const arrayField = computed(
  () => props.field.type === '_text' && !props.contains
);
const displayed = computed(() => {
  if (arrayField.value)
    return Array.isArray(props.modelValue) ? props.modelValue.join('\n') : '';
  return props.modelValue ?? '';
});
const update = value => {
  if (arrayField.value)
    emit('update:modelValue', value.split('\n').filter(Boolean));
  else if (['int4', 'float8'].includes(props.field.type))
    emit('update:modelValue', value === '' ? null : Number(value));
  else emit('update:modelValue', value);
};
</script>

<template>
  <select
    v-if="field.type === 'bool'"
    :value="modelValue === null ? '' : String(modelValue)"
    :aria-label="label"
    class="w-full text-sm"
    @change="
      emit(
        'update:modelValue',
        $event.target.value === '' ? null : $event.target.value === 'true'
      )
    "
  >
    <option value="">—</option>
    <option value="true">{{ t('yes') }}</option>
    <option value="false">{{ t('no') }}</option>
  </select>
  <textarea
    v-else-if="arrayField"
    :value="displayed"
    :aria-label="label"
    class="w-full text-sm"
    rows="3"
    @input="update($event.target.value)"
  />
  <input
    v-else
    :value="displayed"
    :aria-label="label"
    :type="['int4', 'float8'].includes(field.type) ? 'number' : 'text'"
    :placeholder="
      field.type === 'timestamp' ? 'YYYY-MM-DDTHH:mm:ss+03:00' : label
    "
    class="w-full text-sm"
    @input="update($event.target.value)"
  />
</template>
